import * as _ from 'lodash';
import baseRequest from './baseRequest';
import * as loanUtils from 'login-utils/loanUtils';

const baseUrl = 'api/loans';

export const getCurrentUser = async (): Promise<any> => {
  return (await baseRequest.get(`${baseUrl}/current-user`)).data;
};

export const getCurrentLoan = async (): Promise<any> => {
  const loans = await getCurrentUser();
  const loanId = loanUtils.getSelectedProductId();
  if (!loanId) throw new Error('Tried to get current loan, but selectedProductId cookie was not defined.');
  const currentLoan = _.find(loans, loan => loan._id === loanId);
  if (!currentLoan) {
    const notFoundError = new Error(
      `Could not find loan for loan id ${loanId} in list of loan ids: [${_.join(_.map(loans, '_id'), ', ')}].`,
    );
    throw notFoundError;
  }
  return currentLoan;
};

export interface CreateNewLoanParams {
  loanType: DM.LoanType;
  modelProperties?: {
    autoLoanPurposeType?: string;
    autoRefinanceType?: string;
    autoVehicleCondition?: string;
    loanPurpose?: Mismo.LoanPurposeType;
  };
}

export const createNewLoan = async (params: CreateNewLoanParams): Promise<any> => {
  return (await baseRequest.post(`${baseUrl}/additional-borrower-loan`, params)).data;
};

export const hydrateLoan = async (loanId: string): Promise<any> => {
  return await baseRequest.post(`${baseUrl}/${loanId}/hydrate`, {});
};
